{
  "noSitesHint": "Карта строится по узлам площадки. Создайте площадку в разделе «Площадки», затем поставьте на неё агента.",
  "narrowViewOnly": "узкий экран — только просмотр",
  "nothingSelected": "Ничего не выбрано",
  "nothingSelectedHint": "Выберите узел, чтобы увидеть его свойства и мониторы, или связь — чтобы поменять линию или разорвать её.",
  "newFrameName": "Новая группа",
  "newNodeName": "Новый узел",
  "exportFallbackName": "карта",
  "savedOnBlur": "сохраняется при потере фокуса",
  "mode": {
    "view": "Просмотр",
    "edit": "Правка"
  },
  "panel": {
    "link": "Связь",
    "properties": "Свойства",
    "hide": "Скрыть панель свойств",
    "hideTitle": "Скрыть панель свойств — карте достанется весь экран",
    "show": "Показать панель свойств"
  },
  "minimap": {
    "show": "Показывать миникарту",
    "hide": "Скрыть миникарту",
    "hideAria": "Скрыть миникарту. Вернуть — кнопкой на панели карты"
  },
  "grid": {
    "show": "Показывать сетку",
    "showDots": "Показывать точки сетки",
    "hideDots": "Скрыть точки сетки",
    "step": "Шаг сетки",
    "stepHint": "Шаг сетки: к нему прилипают узлы. Запоминается для площадки",
    "stepForbidden": "Шаг сетки меняет тот, у кого есть право на площадку"
  },
  "search": {
    "placeholder": "поиск",
    "aria": "Поиск по карте: имя или адрес",
    "title": "Поиск по имени или адресу; Enter — перейти к найденному",
    "jump": "Перейти к найденному (Enter)",
    "none": "нет"
  },
  "filter": {
    "onlyDown": "упавшие",
    "onlyDownHint": "Показывать только узлы, которые не отвечают",
    "allKinds": "все типы",
    "kindHint": "Показывать только выбранный тип"
  },
  "add": {
    "node": "Узел",
    "group": "Группа",
    "groupTitle": "Добавить группу"
  },
  "undo": "Отменить",
  "undoTitle": "Отменить (Ctrl+Z)",
  "redo": "Вернуть",
  "redoTitle": "Вернуть (Ctrl+Shift+Z)",
  "saveLayoutTitle": "Сохранить расположение (Ctrl+S)",
  "save": {
    "pressSave": "Нажмите «Сохранить»",
    "dirty": "не сохранено: {{what}}",
    "saving": "сохранение…",
    "failed": "не сохранено",
    "saved": "сохранено {{at}}"
  },
  "export": {
    "title": "Экспорт карты",
    "button": "Экспорт",
    "png": "изображение для отчёта",
    "svg": "векторная схема",
    "csv": "список устройств"
  },
  "layers": {
    "title": "Слои карты",
    "short": "Слои",
    "buttonHint": "Слои карты: что видно и куда ложатся новые узлы",
    "showAll": "показать все",
    "show": "Показать слой",
    "hide": "Скрыть слой",
    "showAria": "Показать слой {{name}}",
    "hideAria": "Скрыть слой {{name}}",
    "solo": "Показать только этот слой",
    "soloAria": "Показать только слой {{name}}",
    "restoreAll": "Вернуть все слои",
    "makeActive": "Класть новые узлы на этот слой",
    "rename": "Переименовать",
    "renameAria": "Переименовать слой {{name}}",
    "namePrompt": "Название слоя",
    "deleteAria": "Удалить слой {{name}}",
    "deleteHint": "Удалить слой. Непустой слой удалить нельзя",
    "newLayer": "Новый слой",
    "newLayerAria": "Название нового слоя"
  },
  "color": {
    "default": "по умолчанию",
    "green": "зелёный",
    "yellow": "жёлтый",
    "red": "красный",
    "blue": "синий"
  },
  "group": {
    "expand": "Развернуть группу",
    "collapse": "Свернуть группу",
    "collapsedPrefix": "свёрнута · "
  },
  "frame": {
    "empty": "пусто",
    "color": "Цвет",
    "fill": "Фон",
    "noFill": "без заливки",
    "fillAria": "Фон: {{color}}",
    "fillOpacity": "Плотность заливки",
    "pickFillFirst": "сначала выберите цвет фона",
    "insideFrame": "Внутри рамки",
    "standalone": "сама по себе",
    "layerAria": "Слой рамки",
    "layerHint": "Рамка переезжает на слой вместе со всем, что в ней лежит",
    "layerFromParent": "Вложенная рамка переезжает вместе с родительской",
    "movesWithContent": "вместе с рамкой переедет всё, что внутри",
    "movesWithParent": "вложенная рамка переезжает вместе с родительской",
    "layerIsHidden": "этот слой сейчас скрыт — рамки не будет видно",
    "delete": "Удалить рамку",
    "help": "Узел попадает в рамку перетаскиванием и так же выносится наружу. Щелчок по заголовку сворачивает рамку, и свёрнутой она останется после перезагрузки.",
    "readonlyName": "рамка: {{name}}",
    "readonlyLayer": "слой: {{name}}",
    "readonlyNodes": "узлов внутри: {{count}}",
    "readonlyFill": "фон: {{color}} · {{percent}} %"
  },
  "link": {
    "line": "Линия",
    "routingLabel": "Прокладка",
    "label": "Подпись",
    "labelPlaceholder": "магистраль, 1 Гбит/с",
    "straighten": "Убрать изломы ({{count}})",
    "delete": "Разорвать связь",
    "help": "Двойной щелчок по выделенной линии ставит излом, перетаскивание его двигает, двойной щелчок по нему самому — убирает. Разорвать связь можно и клавишей Delete, выделив её на карте.",
    "readonlyStyle": "линия: {{style}}",
    "readonlyRouting": "прокладка: {{routing}}",
    "readonlyLabel": "подпись: {{label}}",
    "style": {
      "solid": "сплошная",
      "dashed": "пунктир",
      "dotted": "точки"
    },
    "routing": {
      "step": "ломаная",
      "bezier": "кривая",
      "straight": "прямая"
    }
  },
  "menu": {
    "connectVnc": "Подключиться по VNC",
    "openTerminal": "Открыть терминал",
    "noVncPermission": "Нет права подключаться к этому узлу",
    "noSshPermission": "Нет права открывать терминал на этом узле",
    "deleteHint": "Удалить узел вместе с его мониторами. Вернуть отменой нельзя",
    "deleteInEditMode": "Удаление доступно в режиме правки",
    "noWritePermission": "Нет права менять карту"
  },
  "delete": {
    "and": " и ",
    "oneNode": "узел «{{name}}»",
    "manyNodes": "узлов: {{count}}",
    "oneFrame": "рамку «{{name}}»",
    "manyFrames": "рамок: {{count}}",
    "nodeConsequence": "Мониторы будут отключены, история проверок останется на удалённом узле. Вернуть узел отменой нельзя.",
    "frameConsequence": "Узлы внутри рамки останутся на карте.",
    "question": "Удалить {{what}}? {{consequences}}"
  },
  "history": {
    "linkWaypoint": "излом связи",
    "moveFrame": "перемещение рамки",
    "moveNode": "перемещение узла",
    "moveNodes": "перемещение узлов",
    "createLink": "создание связи",
    "deleteFrame": "удаление рамки",
    "deleteLink": "удаление связи",
    "createNode": "создание узла"
  },
  "csv": {
    "noName": "нет имени",
    "name": "имя",
    "address": "адрес",
    "kind": "тип",
    "layer": "слой"
  },
  "import": {
    "title": "Импорт устройств из CSV",
    "short": "Импорт из CSV",
    "intro": "Колонки: имя, адрес, тип, слой. Разделитель — запятая или точка с запятой. Заголовок, если он есть, распознаётся сам. Неизвестный тип заводится как «прочее».",
    "layerFromColumn": "Слой берётся из четвёртой колонки; новых слоёв импорт не заводит.",
    "layerFallback": "Строки без известного слоя лягут на «{{name}}»; новых слоёв импорт не заводит.",
    "parsed": "разобрано строк: {{count}}",
    "notParsed": "не разобрано: {{count}}",
    "problem": "строка {{line}}: {{reason}} — {{text}}",
    "noAddress": "без адреса",
    "andMore": "…и ещё {{count}}",
    "created": "создано {{done}} из {{total}}",
    "createNodes": "Создать {{count}} узлов"
  },
  "discovery": {
    "title": "Найти устройства в подсети",
    "buttonHint": "Найти устройства в подсети: агент опросит её и предложит найденное",
    "intro": "Агент площадки опросит подсеть эхо-запросами и прочитает таблицу соседей. Найденное показывается списком — на карту попадёт только то, что вы отметите.",
    "targetLayer": "Узлы лягут на слой «{{name}}».",
    "subnet": "Подсеть",
    "subnetExample": "например 192.168.10.0/24",
    "addressCount": "будет опрошено {{count}} адресов",
    "scanPorts": "Проверять типовые порты",
    "scanPortsHint": "Проверить типовые порты на отозвавшихся хостах: по ним видно, камера это или принтер",
    "scan": "Сканировать",
    "running": "Идёт опрос…",
    "scanFailed": "Сканирование не удалось",
    "createFailed": "Не удалось создать узлы",
    "nobodyAnswered": "В подсети {{cidr}} никто не ответил. Это не всегда пустая сеть: устройства могут не отвечать на эхо-запросы. Попробуйте включить проверку типовых портов или сканировать соседнюю подсеть.",
    "found": "Найдено {{found}} из {{scanned}} опрошенных адресов",
    "selectNew": "отметить всё новое",
    "clearSelection": "снять отметки",
    "ports": "Порты",
    "addAria": "Добавить {{ip}}",
    "answeredIcmp": "ответил на эхо-запрос",
    "foundByNeighbors": "найден только по таблице соседей",
    "alreadyOnMap": "уже на карте: {{name}}",
    "alreadyOnMapHint": "Этот адрес уже есть на карте",
    "nameAria": "Имя для {{ip}}",
    "kindAria": "Тип для {{ip}}",
    "progress": "Добавлено {{done}} из {{total}}…",
    "addSelected": "Добавить отмеченные ({{count}})"
  },
  "perf": {
    "run": "Прогнать 6 секунд",
    "running": "Идёт замер…",
    "pass": "проходит",
    "fail": "НЕ ПРОХОДИТ",
    "nodes": "узлов {{count}}",
    "frames": "кадров {{count}}",
    "p95": "p95 кадра {{ms}} мс",
    "worst": "худший {{ms}} мс",
    "slow": "медленных {{percent}} %",
    "nodesLabel": "узлов"
  }
}
